import type {
  WritebackFieldValue,
  FieldWritebackCriteriaType,
  FieldWritebackChangeToOperatorType,
} from 'src/types/field-writeback';
import type {NodeSchedule} from 'src/types/node-schedule';
import cloneDeep from 'lodash/cloneDeep';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {
  RECEIVE_FIELD_WRITEBACK_INFO,
  SET_FIELD_WRITEBACK,
  UPDATE_FIELD_WRITEBACK,
  UPDATE_NODE_SCHEDULE,
  RESET_FIELD_WRITEBACK,
  SET_FIELD_WRITEBACK_CHANGE_TYPE,
  SET_FIELD_WRITEBACK_FIELD,
  SET_FIELD_WRITEBACK_VALUE,
  SET_FIELD_WRITEBACK_CHANGE_TO_OPERATOR,
  SET_FIELD_WRITEBACK_EXTERNAL_SOURCE_ID_SENSE_ID_MAP,
  type FieldWritebackAction,
} from 'src/action-creators/field-writeback';


export type FieldWritebackState = {
  criteria_type: FieldWritebackCriteriaType;
  writebackFields: Array<WritebackFieldValue>;
  changeToOperator: FieldWritebackChangeToOperatorType;
  userExternalSourceIdSenseIdMap: {
    [key: string]: string | null | undefined;
  };
} & NodeSchedule;

const initialState = {
  criteria_type: 'field',
  writebackFields: [], //currently only one value can be there
  // but in future we can have multiple values e.g. city and pincode
  // and both are required to be updated
  changeToOperator: 'empty',
  userExternalSourceIdSenseIdMap: {},
  ...getDefaultNodeScheduleState({}),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly date_type?: string; readonly date_value?: string; readonly time_type?: string; readonly time_value?: string; readonly offset?: number; readonly date_field?: string | null | undefined; ... 11 more ...; readonly userExternalSourceIdSenseIdMap: {}; }' is not assignable to type 'FieldWritebackState'.
  state: FieldWritebackState = initialState,
  action: FieldWritebackAction,
): FieldWritebackState => {
  switch (action.type) {
    case RECEIVE_FIELD_WRITEBACK_INFO: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATE_FIELD_WRITEBACK: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_FIELD_WRITEBACK: {
      const payload = cloneDeep(initialState);
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 9 more ...; userExternalSourceIdSenseIdMap: {}; }' is not assignable to type 'FieldWritebackState'.
      return {
        ...state,
        ...payload,
      };
    }

    case SET_FIELD_WRITEBACK_CHANGE_TYPE: {
      const {payload} = action;
      const newState = cloneDeep(initialState);
      // @ts-expect-error - TS2540 - Cannot assign to 'criteria_type' because it is a read-only property.
      newState.criteria_type = payload;
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 9 more ...; userExternalSourceIdSenseIdMap: {}; }' is not assignable to type 'FieldWritebackState'.
      return {
        ...state,
        ...newState,
      };
    }
    case SET_FIELD_WRITEBACK: {
      const {payload} = action;
      return {
        ...state,
        ...payload,
      };
    }
    case SET_FIELD_WRITEBACK_FIELD: {
      const {payload} = action;
      return {
        ...state,
        //this may change in future when we have multiple fields
        writebackFields: [payload],
      };
    }
    case SET_FIELD_WRITEBACK_VALUE: {
      const {relationScopedId, value} = action.payload;
      return {
        ...state,
        //this may change in future whn we have multiple fields
        writebackFields: state.writebackFields.map((field) => {
          if (field.relationScopedId === relationScopedId) {
            return {
              ...field,
              value,
            };
          }
          return field;
        }),
      };
    }
    case SET_FIELD_WRITEBACK_EXTERNAL_SOURCE_ID_SENSE_ID_MAP: {
      const {payload} = action;
      return {
        ...state,
        userExternalSourceIdSenseIdMap: {
          ...payload,
        },
      };
    }
    case SET_FIELD_WRITEBACK_CHANGE_TO_OPERATOR: {
      const {relationScopedId, value} = action.payload;
      return {
        ...state,
        changeToOperator: value,
        //this may change in future whn we have multiple fields
        writebackFields: state.writebackFields.map((field) => {
          if (field.relationScopedId === relationScopedId) {
            return {
              ...field,
              value: [],
            };
          }
          return field;
        }),
      };
    }
  }
  return state;
};
